
import React, { useEffect, useState } from 'react';

import { t } from 'i18next';
import { baseURL, imageURL } from '../components/MyApi';
import { useTranslation } from 'react-i18next';


function Municipalite() {

  const { i18n } = useTranslation()
  const currentLanguageCode = i18n.language

  const [libelle, setLibelle] = useState(null);
  const [logo, setLogo] = useState(null);
  const [gouvernorat, setGouvernorat] = useState(null);
  const [adresse, setAdresse] = useState(null);
  const [email, setEmail] = useState(null);
  let [phone1, setPhone1] = useState(null);
  let [phone2, setPhone2] = useState(null);
  let [fax, setFax] = useState(null);
  let [superficie, setSuperficie] = useState(null);
  let [siteweb, setSiteweb] = useState(null);
  let [facebook, setFacebook] = useState(null);

  // ----------- Get the municipalite Name from URL Query Params START-------------
  const search = window.location.search;
  const params = new URLSearchParams(search);
 
  // ----------- Get the municipalite Name from URL Query Params END-------------

  useEffect(() => {


    fetch(baseURL + '/getInfos', {
			"method": "GET",
			"headers": {
			  "content-type": "application/json",
			  "accept": "application/json"
			},
		  })
		  .then(response => response.json())
		  .then(response => {
			
			  setLibelle(currentLanguageCode === 'fr'? response.libelle:response.libelle_ar);
			  setLogo(imageURL+response.logo);
        setGouvernorat(currentLanguageCode === 'fr' ? response.gouvernorat : response.gouvernorat_ar);
        setAdresse(currentLanguageCode === 'fr' ? response.adresse : response.adresse_ar);
        setEmail(response.email);
        setPhone1(response.phone1);
        setPhone2(response.phone2);
        setFax(response.fax);
        setSuperficie(response.superficie);
        setSiteweb(response.siteweb);
        setFacebook(response.facebook);
        
		  })
		  .catch(err => {
			console.log(err);
		  })

  }, [currentLanguageCode]);

  return (

    <section className="services-section-four pad210_0">
  
      <div className='auto-container'>
        <div className='row'>

        <div className='col-md-3 offset-md-3'>
          <img className='img-thumbnail height370' src={logo} alt='' title='' />
          </div>
          <div className='col-md-5'>

              <ul className='indexList'>
                  <li className='fs25 text-center'>
                    {libelle}
                  </li>
                  <li>
                    <i className="fa fa-map-o"></i> 
                    <span>{gouvernorat}</span>
                  </li>
                  
                  <li>
                    <i className="fa fa-map-marker"></i> 
                    <span>{adresse}</span>
                  </li>

                  <li>
                    <i className="fa fa-envelope-o"></i> 
                    <span>{email}</span>
                  </li>

                  {phone1?<li><i className="fa fa-phone"></i> <span>{phone1}</span></li>:''} 
                  {phone2?<li><i className="fa fa-phone-square"></i> <span>{phone2}</span></li>:''} 
                  {fax?<li><i className="fa fa-fax"></i><span>{fax}</span></li>:''} 
                  
                  {facebook?<li> <i className="fa fa-facebook "></i><a href={facebook} target="_blank" rel="noreferrer"><span>{t('CliquerIci')}</span></a></li>:''} 
                  {siteweb?<li> <i className="fa fa-globe "></i> <a href={siteweb} target="_blank" rel="noreferrer"><span>{t('CliquerIci')}</span></a></li>:''}
              </ul>

              


          </div>
     
          </div>


        </div>

    </section>
  )
}



export default Municipalite  